<script setup lang="ts">
import { Textarea } from '@zerohuman/ui'

/**
 * Everything else a screen gives the field (`aria-invalid`, `aria-describedby`, a blur handler for its
 * as-you-type check, #1757) belongs on the textarea, not on the label around it.
 */
defineOptions({ inheritAttrs: false })

defineProps<{ id: string }>()
const model = defineModel<string>({ required: true })
</script>

<template>
    <label class="block text-sm" :for="id">
        <span class="text-muted-foreground">Extra sign-in parameters, name=value per line</span>
        <Textarea :id="id" v-bind="$attrs" v-model="model" rows="4" class="mt-1" />
        <p class="text-muted-foreground mt-1 text-xs">
            Optional settings required by the provider. These are saved with the connection and are not secret.
            Client credentials, redirect address, security checks and permissions are managed separately.
        </p>
    </label>
</template>
